export class AccountVoidAdjustmentCommand {
    accountNumber: string;
    adjustmentId: string;
    isVoided: boolean;

    constructor(accountNumber: string, adjustmentId: string, isVoided: boolean) {
        this.accountNumber = accountNumber;
        this.adjustmentId = adjustmentId;
        this.isVoided = isVoided;
    }
}
